module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<table class=\'ui-schedule-table\'>\n    <thead>\n    <tr>\n        <th class=\'day\' rowspan=\'2\'>' +
((__t = ( i18next.t('common.day') )) == null ? '' : __t) +
'</th>\n        ';
 WiseMetering.weekdays.forEach(function(weekday) { ;
__p += '\n            <th colspan=\'4\'>' +
((__t = ( i18next.t(`weekdays.${weekday}`) )) == null ? '' : __t) +
'</th>\n        ';
 }) ;
__p += '\n    </tr>\n    <tr>\n        ';
 for(let i = 0; i < WiseMetering.weekdays.length; i++) { ;
__p += '\n            ';
 ['00', '15', '30', '45'].forEach(function(interval) { ;
__p += '\n                <th>' +
((__t = ( interval )) == null ? '' : __t) +
'</th>\n            ';
 }) ;
__p += '\n        ';
 } ;
__p += '\n    </tr>\n    </thead>\n    <tbody>\n    ';
 for(let i = 0; i <= 23; i++) { ;
__p += '\n        <tr>\n            <td class=\'day\'>\n                ' +
((__t = ( WiseMetering.utils.pad2(i) + ':00' )) == null ? '' : __t) +
'\n                ';
 _.each(WiseMetering.weekdays, function(weekday, index) { ;
__p += '\n                    ';
 for(let j = 0; j <= 3; j++) { ;
__p += '\n                        ';
 const value = schedule?.[weekday]?.[i * 4 + j] || 'off'; ;
__p += '\n            <td\n                    class="input' +
((__t = ( editable ? '' : ' pointer-show' )) == null ? '' : __t) +
'' +
((__t = ( j % 4 === 3 ? ' day-change' : '' )) == null ? '' : __t) +
'"\n                    data-x=\'' +
((__t = ( index * 4 + j )) == null ? '' : __t) +
'\'\n                    data-y=\'' +
((__t = ( i )) == null ? '' : __t) +
'\'\n                    style="background-color: ' +
((__t = ( colors[value] )) == null ? '' : __t) +
';"\n            >\n                <input\n                        id=\'schedule-' +
((__t = ( weekday )) == null ? '' : __t) +
'-' +
((__t = ( i * 4 + j )) == null ? '' : __t) +
'\'\n                        name=\'alarm_schedule[' +
((__t = ( weekday )) == null ? '' : __t) +
'][]\'\n                        type=\'hidden\'\n                        value=\'' +
((__t = ( value )) == null ? '' : __t) +
'\'\n                >\n            </td>\n            ';
 } ;
__p += '\n            ';
 }) ;
__p += '\n        </tr>\n    ';
 } ;
__p += '\n    </tbody>\n</table>\n';

}
return __p
}